// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__FVYCr","spin":"Spinner_spin__9huCY"};